import React from "react";
import Container from "../components/Container/index";

function About() {
  return (
    <Container>
      <div>
        <h3>About me</h3>
        <p>
        Hardworking individual that excels in fast working environments and accepts and overcomes any challenges I come across. Recently earned a certificate in full stack development from the University of Arizona, with newly developed skills in JavaScript, CSS, React.js, and responsive web design. Known as an innovative problem solver passionate about developing apps, with a focus on mobile-first design and development.
        </p>
      </div>
    </Container>
  );
}

export default About;
